module.exports = __webpack_public_path__ + "img/i-cross-black.1f2085a2.svg";